import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerTypeHint,
} from "@capacitor/barcode-scanner";
import { useMutation } from "@tanstack/react-query";

interface RecognizedBarcode {
  readonly barcode: string;
  readonly format: string;
}

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBarcodeRecognitionActions() {
  const scanBarcode = useMutation({
    mutationFn: async (): Promise<RecognizedBarcode> => {
      const { ScanResult, format } = await CapacitorBarcodeScanner.scanBarcode({
        hint: CapacitorBarcodeScannerTypeHint.ALL,
      });

      return {
        barcode: ScanResult,
        format: CapacitorBarcodeScannerTypeHint[format] ?? "Unknown",
      };
    },
  });

  return { scanBarcode };
}
